/**
 * Resolve a possibly-relative storage URL to an absolute one.
 *
 * Background: legacy rows in `annotation_photo` historically stored
 * absolute S3 URLs in the `imageUrl` field (echoed by the Spring Boot
 * Lambda). PR #305 migrated those rows to relative Supabase storage
 * paths like `public-anatomy/man-front-body.png`. The Next.js proxy
 * already transforms relative → absolute, but the CRA app on
 * www.sistemklinik.com talks to the Lambda directly and receives the
 * raw column value. This helper mirrors the proxy's transform so CRA
 * tolerates either shape.
 *
 * @param {string|null|undefined} url
 * @returns {string|undefined} absolute URL, or undefined for falsy input
 */
export const resolveStorageUrl = (url) => {
  if (!url) return undefined;
  if (/^https?:\/\//i.test(url)) return url;
  const base = process.env.REACT_APP_SUPABASE_URL;
  if (!base) return url;
  const clean = url.replace(/^\/+/, "");
  return `${base}/storage/v1/object/public/${clean}`;
};
